import snakecaseKeys from 'snakecase-keys';
import { JobStageList } from '../../../../entities/v1/JobStageList';
import { ApiService } from '../../../ApiService';

export interface ListParams {
  id?: number;
  jobId?: number;
  name?: string;
  page?: number;
  pageSize?: number;
  expand?: string[];
}

export class JobStageService {
  public static list(params: ListParams) {
    return ApiService.get<JobStageList>(
      '/api/v1/applicant_tracking/job_stages',
      snakecaseKeys(params),
    );
  }
}
